import React from "react";

function Die(props){
    return(
        <div className={`dice-block ${props.locked && "dice-locked"}`} onClick={() => props.toggleDiceLock(props.id)}>
            <img src={`images/LC-${props.value}.png`}/>
        </div>
    )
}
export default Die